// Blood group options
export const BLOOD_GROUPS = [
  { value: "", label: "Select Blood Group" },
  { value: "A+", label: "A+" },
  { value: "A-", label: "A-" },
  { value: "B+", label: "B+" },
  { value: "B-", label: "B-" },
  { value: "O+", label: "O+" },
  { value: "O-", label: "O-" },
  { value: "AB+", label: "AB+" },
  { value: "AB-", label: "AB-" },
  { value: "A1+", label: "A1+" },
];

// Gender options
export const GENDER_OPTIONS = [
  { value: "", label: "Select Gender" },
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
];

// Yes/No options
export const YES_NO_OPTIONS = [
  { value: "", label: "Select" },
  { value: "Yes", label: "Yes" },
  { value: "No", label: "No" },
];

// Membership status options
export const MEMBERSHIP_STATUS = [
  { value: "New Registration", label: "New Registration" },
  { value: "Old Member Data Updation", label: "Old Member Data Updation" },
];

// Number of kids options
export const KIDS_COUNT_OPTIONS = [
  { value: "0", label: "0" },
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
];

// Number of participants options
export const PARTICIPANT_COUNT_OPTIONS = [
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
];

// Navigation items
export const NAV_ITEMS = [
  "home",
  "about",
  "events",
  "team",
  "gallery",
  "register",
  "contact",
];

// Bank details for payment. One account for every paid event.
export const BANK_DETAILS = {
  name: "SHREE MAHESWARI YUVA MANDAL",
  bankName: "Karur Vysya Bank",
  branch: "Godown St Branch, Chennai - 600 001",
  accountNumber: "1755115000000465",
  ifscCode: "KVBL0001755",
};

export const PAYMENT_HELPLINE = {
  digits10: "8610447053",
  display: "86104 47053",
};

/** Event note under the bank card. Hide a note that only repeats the shared account. */
export function extraPaymentNote(instructions) {
  const text = typeof instructions === "string" ? instructions.trim() : "";
  if (!text || text.includes(BANK_DETAILS.accountNumber)) return "";
  return text;
}
